import locale from "common/managers/locale";
export default {

    /**
     * Toggle the detail row.
     * @param row
     */
    toggleDetailRow: function(row) {
        row.find(".k-hierarchy-cell>a").click();
    },

    /**
     * Add a default detailTemplate if detailRowField is set.
     * @private
     */
    _configDetailRow: function(options) {
        if (options.detailRowField && !options.detailTemplate) {
            options.detailTemplate = "<span class='detailWrapper'>#:" + options.detailRowField + "#</span>"
        }
    },

    /**
     * Add the custom detail row options to DFGrid.
     * @private
     */
    _prepareDetailRow: function() {
        if (this.options.bindWidgetsInDetailRow) {
            this.bind("detailInit", function(e) {
                this.one("detailExpand", function(e1) {
                    e1.masterRowData = e.data;
                    e1.bindTo = this.options.bindWidgetsInDetailRow === "new" ? kendo.observable({}) : e.data;
                    this._haltRefresh = true;
                    this.trigger("detailFirstExpand", e1);
                    this._haltRefresh = false;
                    kendo.bind(e.detailCell, e1.bindTo);
                });
                this.one("dataBinding", function() {
                    kendo.destroy(e.detailCell);
                });
            });
        }



        if (this.options.detailTemplate && this.options.detailRowField) {
            var me = this;
            this.bind("dataBound", function(e) {
                this.tbody.find('tr.k-master-row').each(function() {
                    var row = $(this);
                    var item = me.dataItem(row);
                    if (!item.get(me.options.detailRowField)) {
                        row.addClass("hideDetails");
                        row.find('.k-hierarchy-cell a')
                            .click(function(e) {
                                e.stopImmediatePropagation();
                                return false;
                            });
                    }
                });
            });
        }

        if (this.options.autoExpandDetailRow !== false) {
            this.element.on("click", ".k-master-row", function(e) {
                $(this).find(".k-hierarchy-cell a").click()
            });
        }

        if (this.options.detailTemplate) {
            this.bind("detailInit", function(e) {
                e.detailCell.attr("aria-describedby", this._getDetailDescription());
            });
        }
    },

    _detailDesc: null,

    _getDetailDescription: function() {
        if (!this._detailDesc) {
            this._detailDesc = $("<div>").hide().attr("id", kendo.guid()).text(locale.get("detail.row.desc"));
            this.wrapper.append(this._detailDesc);
        }
        return this._detailDesc.attr("id");
    }
};
